'use client'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Typography } from '@mui/material'
import React, { ReactElement, useState } from 'react'

export const FAQSection = (): ReactElement => {
	const [expanded, setExpanded] = useState<string | false>('')

	const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
		setExpanded(isExpanded ? panel : false)
	}

	const faqItems = [
		{
			id: 'panel1',
			question: 'Apakah ada biaya untuk membuka toko di UMKMs?',
			answer: `Tidak ada biaya sama sekali untuk membuka dan mendaftarkan toko Anda di UMKMs! Kami menyediakan paket dasar yang gratis selamanya, memungkinkan Anda untuk mulai berjualan secara online tanpa modal awal. Kami juga menawarkan paket premium dengan fitur-fitur tambahan yang bisa Anda pilih jika bisnis Anda sudah semakin berkembang.`
		},
		{
			id: 'panel2',
			question: 'Dokumen apa saja yang perlu saya siapkan untuk mendaftar?',
			answer: `Untuk pendaftaran awal sebagai individu, Anda hanya perlu menyiapkan KTP dan nomor telepon aktif untuk verifikasi. Jika Anda mendaftar sebagai badan usaha (CV/PT), tim kami mungkin akan meminta dokumen tambahan seperti NPWP dan NIB untuk proses verifikasi lebih lanjut guna meningkatkan kepercayaan pelanggan.`
		},
		{
			id: 'panel3',
			question: 'Bagaimana cara mengatur profil atau tampilan toko saya?',
			answer:
				'Setelah login, masuk ke menu "Pengaturan Toko" di dasbor Anda. Di sana, Anda bisa dengan mudah mengunggah logo, menambahkan foto sampul (banner), menulis deskripsi singkat tentang toko Anda, serta mengatur informasi kontak dan alamat. Personalisasi ini membantu toko Anda terlihat lebih profesional dan menarik.'
		},
		{
			id: 'panel4',
			question: 'Bagaimana cara mengunggah produk ke toko saya?',
			answer:
				'Sangat mudah! Di dasbor Anda, klik menu "Produk" lalu pilih "Tambah Produk Baru". Anda akan diminta untuk mengisi nama produk, mengunggah foto-foto produk dari berbagai sisi, menulis deskripsi yang menarik, menetapkan harga, dan mengatur jumlah stok. Setelah selesai, klik "Simpan" dan produk Anda akan langsung tampil di toko.'
		}
	]

	return (
		<section id='faq-container'>
			<Box py={14} className='py-56'>
				<Container maxWidth='xl'>
					<Box display='flex' flexDirection='column' alignItems='center' gap={3.75}>
						<Typography variant='h4' component='h2' fontFamily='Poppins' fontWeight='bold' color='#000000'>
							FAQ
						</Typography>

						<Box width='100%' px={{ xs: 2, md: 6, lg: 12 }} py={6}>
							{faqItems.map((item) => (
								<Box key={item.id} mb={2}>
									<Accordion
										expanded={expanded === item.id}
										onChange={handleChange(item.id)}
										elevation={1}
										sx={{
											'bgcolor': 'grey.50',
											'borderRadius': '8px',
											'mb': 1,
											'&:before': {
												display: 'none'
											}
										}}>
										<AccordionSummary expandIcon={<KeyboardArrowDownIcon />} aria-controls={`${item.id}-content`} id={`${item.id}-header`} sx={{ py: { xs: 1 }, px: { xs: 2, md: 3 } }}>
											<Typography fontFamily='Poppins' fontWeight='600' className='text-base sm:text-lg'>
												{item.question}
											</Typography>
										</AccordionSummary>
										{item.answer && (
											<AccordionDetails sx={{ pt: 0, pb: 4, px: { xs: 2, md: 3 } }}>
												<Typography fontFamily='Poppins' fontWeight='normal' color='#000000' className='text-sm sm:text-base leading-relaxed'>
													{item.answer}
												</Typography>
											</AccordionDetails>
										)}
									</Accordion>
								</Box>
							))}
						</Box>
					</Box>
				</Container>
			</Box>
		</section>
	)
}
